import React from "react";
import PatientEnrolmentBookEyeCheckEmailSection from "./PatientEnrolmentBookEyeCheckEmailSection";

type Props = {
  showEmailField: boolean;
  showEmailFieldOnClick: () => void;
  showPrintView: () => void;
  email: string;
  emailOnChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  sendEmail: (event: React.MouseEvent<HTMLDivElement>) => void;
  sendEmailSuccess: string;
  sendEmailError: string;
};

const PatientEnrolmentBookEyeCheckStepOne = ({
  showEmailField,
  showEmailFieldOnClick,
  showPrintView,
  email,
  emailOnChange,
  sendEmail,
  sendEmailSuccess,
  sendEmailError,
}: Props) => (
  <section
    className="light-blue-background"
    id="patient-enrolment-book-eye-check-step-one"
  >
    <div className="mdc-layout-grid max-width">
      <div className="mdc-layout-grid__inner">
        <div className="mdc-layout-grid__cell mdc-layout-grid__cell--span-6 mdc-layout-grid__cell--span-8-tablet">
          <h2 className="step-heading">Step 1</h2>

          <div className="section-content">
            <p className="step-heading-label">
              Get your personalised KeepSight visit information
            </p>
          </div>

          <div className="section-content">
            <p>
              Take this information with you when you go to your appointment
              with the eye care provider of your choice.
            </p>
          </div>

          <div className="section-content">
            <div
              className="step-one-button primary-button"
              id="email-me-button"
              data-testid="email-me-button"
              onClick={showEmailFieldOnClick}
            >
              <i className="material-icons mdc-button__icon" aria-hidden="true">
                email
              </i>
              EMAIL ME
            </div>
            <div
              className="step-one-button primary-button"
              id="submit-print"
              onClick={showPrintView}
            >
              <i className="material-icons mdc-button__icon" aria-hidden="true">
                print
              </i>
              PRINT
            </div>
          </div>
          {showEmailField && (
            <PatientEnrolmentBookEyeCheckEmailSection
              email={email}
              emailOnChange={emailOnChange}
              sendEmail={sendEmail}
              sendEmailSuccess={sendEmailSuccess}
              sendEmailError={sendEmailError}
            />
          )}
        </div>

        <div className="mdc-layout-grid__cell mdc-layout-grid__cell--span-6 step-one-image">
          <div className="mdc-layout-grid__cell mdc-layout-grid__cell--span-6 text-center">
            <img src="/images/eye-check.jpg" />
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default PatientEnrolmentBookEyeCheckStepOne;
